import bg from "../../images/crew/background-crew-desktop.jpg";
import NavBar from "../navbar/MainNavBar";
import { useState } from "react";
import { data } from "./data";

const DeskCrew = () => {
  const [currentPage, setCurrentPage] = useState(0);
  let render = data[currentPage];

  const myStyle = {
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
  };

  const handleGoTo = (dataIndex) => {
    setCurrentPage(dataIndex);
  };

  return (
    <div>
      {" "}
      <div style={myStyle}>
        <NavBar />
        <p className="p-style" style={{ margin: " 4rem 0 3rem 7rem" }}>
          {" "}
          <strong className="strong">01</strong>MEET YOUR CREW
        </p>
        <div
          style={{
            padding: "0 2rem",
            textAlign: "left",
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            width: "84%",
            margin: "3rem auto 0",
            position: "relative",
          }}
        >
          <div style={{ width: "49rem" }}>
            <h4
              style={{
                textTransform: "uppercase",
                fontSize: "2rem",
                lineHeight: "36.7px",
              }}
            >
              {render.title}
            </h4>
            <h3
              style={{
                margin: ".5rem 0 1rem",
                textTransform: "uppercase",
                fontSize: "3rem",
                lineHeight: "64px",
              }}
            >
              {render.name}
            </h3>
            <p style={{ width: "58%" }}>{render.text}</p>
            <div
              className="circle-box"
              style={{ width: "6rem", margin: "4rem -.5rem" }}
            >
              {data.map((data, dataIndex) => (
                <div
                  key={dataIndex}
                  className={dataIndex === currentPage ? "active-box" : "box"}
                  onClick={() => handleGoTo(dataIndex)}
                >
                  ●
                </div>
              ))}
            </div>
          </div>
          <img
            src={render.img}
            style={{
              height: "35rem",
              width: "28rem",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DeskCrew;
